// ClearInputContext.js
import React from 'react';

const ClearInputContext = React.createContext({
  clearInput: () => {}, // A no-op function for now
});

export default ClearInputContext;
